<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="OrdersDetailsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('common.addition')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="alert alert-primary d-flex">
            <input v-model="keyword" class="form-control form-control-sm width-40 mr-2" type="text" :placeholder="translations('common.keyword_search')" @keyup.enter="searchProducts">
            <button type="button" class="btn btn-sm btn-primary" @click="searchProducts()">{{translations('common.search')}}</button>
            <input
              v-model="isOutlet"
              type="checkbox" id="outlet"
              name="outlet"
              class="pointer-clickable input-select-type"
              :disabled="isNotGood"
              @change="changeTypeSearch">
              <label class="center-input-here" for="outlet">{{translations('common.outlet')}}</label>
            <input
              v-model="isNotGood"
              type="checkbox" id="notgood"
              name="notgood"
              class="pointer-clickable input-select-type"
              :disabled="isOutlet"
              @change="changeTypeSearch">
              <label class="center-input-here" for="notgood">{{translations('common.not_good')}}</label>
          </div>
          <div id="add-order-product-list" class="table-scroll">
          <table class="table table-striped table-align-middle">
            <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
            <thead>
              <tr>
                <th>{{translations('order.item_number')}}</th>
                <th>{{translations('order.jan_code')}}</th>
                <th>{{translations('order.model')}}</th>
                <th>{{translations('order.quantity')}}</th>
                <th>{{translations('order.unit_price')}}</th>
                <th>{{translations('order.client_order_number')}}</th>
                <th>{{translations('order.summary')}}</th>
                <th v-if="!conditionType">{{translations('order.current_inventory')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(product, key) in tempDetails">
                <tr :key="key">
                  <td>{{product.item_no}}</td>
                  <td>{{product.jan_code}}</td>
                  <td>{{product.type_number}}</td>
                  <td><input class="form-control min-width-120" type="text" v-on:keyup="quantityKeyUp($event,product)" @change="onChangeValueQuantity($event,product,key)" v-model="product.quantity"></td>
                  <td><input class="form-control min-width-120" type="text" :placeholder="tempUnitPrices[key]" v-model="product.unit_price"></td>
                  <td><input class="form-control min-width-120" type="text" v-model="product.client_order_number"></td>
                  <td><input class="form-control min-width-120" type="text" v-model="product.remarks"></td>
                  <td v-if="!conditionType">
                    {{ product.stock_quantity }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="updateDetails()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { CONDITIONS_INVENTORY } from '../constants'
import { mapState } from 'vuex'

export default {
  name: 'OrdersDetailsModal',
  components: {
    VueElementLoading
  },
  props: {
    tax: {},
    details: {},
    ordersInfo: {},
    clients_id: Number
  },
  data: function () {
    return {
      tempDetails: [],
      isSearching: false,
      keyword: '',
      tempUnitPrices: [],
      isOutlet: false,
      isNotGood: false
    }
  },
  watch: {
    details: {
      handler (data, oldData) {
        data.forEach((d, i) => {
          if (oldData[i] !== undefined) {
            d = this.prepareDetails(d)
          }
        })
      },
      deep: true
    }
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.onShown)
  },
  computed: {
    ...mapState(['currentLanguage']),
    conditionType () {
      if (this.isOutlet === this.isNotGood) { return CONDITIONS_INVENTORY.good.value }
      return this.isOutlet ? CONDITIONS_INVENTORY.outlet.value : CONDITIONS_INVENTORY.bad.value
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    quantityKeyUp (event, product) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      product.quantity = value
    },
    onShown (evt) {
      this.tempDetails = []
      this.keyword = ''
      this.tempUnitPrices = []
      document.getElementById('add-order-product-list').style.height = (window.innerHeight - 280) + 'px'
    },

    changeTypeSearch () {
      this.searchProducts()
    },

    async searchProducts () {
      if (this.$props.ordersInfo.division_type === 'B') {
        if (!this.$props.ordersInfo.warehouse_id_from) {
          this.$toastr.warning(this.translations('order.notice_delivery_source'))
          return
        } else if (!this.$props.ordersInfo.warehouse_id) {
          this.$toastr.warning(this.translations('order.notice_delivery_destination'))
          return
        }
      } else {
        if (this.$props.clients_id === undefined || this.$props.clients_id === 0) {
          this.$toastr.warning(this.translations('order.warning_choose_billing'))
          return
        }
      }

      this.isSearching = true
      try {
        let params = {
          keyword: this.keyword,
          clients_id: this.clients_id,
          condition: this.conditionType,
          division_type: this.$props.ordersInfo.division_type
        }

        let cList = await this.$http.post(this.$api_url.products_keyword_search, params)

        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'OrdersDetailsModal:searchProducts')

        if ($data.success === true) {
          this.tempDetails = $data.data

          this.tempUnitPrices = []
          this.tempDetails.forEach((product, index) => {
            this.tempUnitPrices.push(product.unit_price)
            product.client_order_number = this.$storage.get('OrdersDetailsModal.client_order_number', product.client_order_number) ? this.$storage.get('OrdersDetailsModal.client_order_number', product.client_order_number) : ''
          })
        } else {
          this.tempDetails = []
        }
        this.isSearching = false
      } catch (error) {
        console.log('OrdersDetailsModal:searchProducts:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },
    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_profit = data.total_unit_price - data.total_cost

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
        data.total_profit_inctax = data.total_profit
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
        data.total_profit_inctax = this.$util.getIncludeTax(data.total_profit, data.tax_rate)
      }

      return data
    },
    onChangeValueQuantity (event, product, key) {
      if (event.target.value !== '') {
        this.tempDetails[key].selected = true
      } else {
        this.tempDetails[key].selected = false
      }
    },
    updateDetails: function () {
      let $this = this
      this.tempDetails.forEach((item) => {
        if (Number(item.quantity) > 0 || ((!item.quantity || Number(item.quantity) === 0) && item.is_intangible_assets === 1 && item.selected === true)) {
          // 無形資産の場合は個数を1にする
          if (item.is_intangible_assets === 1) {
            item.quantity = 1
          }
          if (this.$props.ordersInfo.division_type === 'B') {
            item.row_price = 0
          }
          let price
          let priceInctax
          if ($this.$props.tax.taxIncluded) {
            price = $this.$util.getExcludeTax(item.unit_price, $this.$props.tax.taxRate)
            priceInctax = item.unit_price
          } else {
            price = item.unit_price
            priceInctax = $this.$util.getIncludeTax(item.unit_price, $this.$props.tax.taxRate)
          }

          item.tax_rate = $this.$props.tax.taxRate
          item.taxclass_id = '1'
          item.unit_price = price
          item.unit_price_inctax = priceInctax
          item = $this.prepareDetails(item)
          item.is_outlet = $this.isOutlet
          item.is_bad = $this.isNotGood
          $this.$storage.set('OrdersDetailsModal.client_order_number', item.client_order_number) // SAVE LATEST
          console.log('OrdersDetailsModal.client_order_number: ', item)
          $this.$props.details.push(item)
        }
      })
      this.isOutlet = false
      this.isNotGood = false
      this.$refs.closeModal.click()
    },
    isLoadingQuantity (index) {
      return this.tempDetails[index].quantity_full_warehouse === undefined
    }
  }
}
</script>
<style scoped>
  .input-select-type {
    margin-top: 0;
    margin-left: 10px;
    margin-right: 5px;
  }
  .center-input-here {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }
</style>
